import { errorMessage } from '@/ai/services/api'
import { pickFeedbackTitle, reasonCodes } from '@/ai/presentation/feedback-copy'

// 方法绑定到原页面实例；不持有独立状态、请求实例或生命周期。
export default {
  isFeedbackBusy(turn) {
    return !!this.feedbackPending[turn.turnId]
  },
  async toggleFeedback(turn, rating) {
    if (this.isFeedbackBusy(turn)) return
    if (this.ratingOf(turn) === rating) return this.feedback(turn, 'NONE')
    if (rating === 'DISLIKE') return this.openFeedback(turn)
    return this.feedback(turn, rating)
  },
  ratingOf(turn) {
    return Object.prototype.hasOwnProperty.call(this.ratings, turn.turnId)
      ? this.ratings[turn.turnId]
      : turn.feedback && turn.feedback.rating
  },
  feedbackReceipt(turn) {
    if (this.ratingOf(turn) === 'LIKE') return this.feedbackCopy.likeSaved
    const detail = turn.feedback
    return detail && ((detail.reasonCodes && detail.reasonCodes.length) || detail.detail) ? this.feedbackCopy.detailSaved : this.feedbackCopy.dislikeSaved
  },
  async openFeedback(turn) {
    if (this.isFeedbackBusy(turn)) return
    if (this.feedbackOpen !== turn.turnId) this.feedbackTitle = pickFeedbackTitle(this.feedbackTitle)
    this.feedbackOpen = turn.turnId
    this.feedbackError = ''
    this.feedbackComment = (turn.feedback && turn.feedback.detail) || ''
    this.feedbackReason = reasonCodes(this.feedbackDetails[turn.turnId] || (turn.feedback && turn.feedback.reasonCodes))
    // Reveal the opened panel, including older replies; do not jump to an unrelated latest turn.
    this.$nextTick(() => {
      if (this.feedbackOpen !== turn.turnId) return
      const refs = this.$refs.feedbackPanel
      const panel = Array.isArray(refs) ? refs[0] : refs
      if (panel) panel.scrollIntoView({ block: 'end', behavior: 'auto' })
    })
    if (this.ratingOf(turn) !== 'DISLIKE') await this.feedback(turn, 'DISLIKE')
  },
  async feedback(turn, rating, selectedReasons = [], detail = '', close = false) {
    const reasons = reasonCodes(selectedReasons)
    if (this.isFeedbackBusy(turn) || (close && !reasons.length && !detail.trim())) return
    this.$set(this.feedbackPending, turn.turnId, true)
    if (this.feedbackOpen === turn.turnId) this.feedbackError = ''
    try {
      await this.call('feedback/save', {
        sessionId: turn.sessionId, turnId: turn.turnId, rating, reasonCodes: reasons,
        detail: detail.trim() || null
      })
      this.$set(turn, 'feedback', rating === 'NONE' ? null : { rating, reasonCodes: reasons, detail: detail.trim() || null })
      this.$set(this.ratings, turn.turnId, rating === 'NONE' ? null : rating)
      this.$set(this.feedbackDetails, turn.turnId, reasons)
      if (this.feedbackOpen === turn.turnId && (close || rating === 'LIKE' || rating === 'NONE')) this.feedbackOpen = null
    } catch (error) {
      if (this.feedbackOpen === turn.turnId) this.feedbackError = errorMessage(error)
      else this.fail(error)
    } finally {
      this.$delete(this.feedbackPending, turn.turnId)
    }
  }
}
